<!-- ChatWindow.vue -->
<template>
    <div class="chat-bubble-container">
        <transition name="fade-scale">
            <!-- Chat Window for Logged In Users -->
            <section v-if="isOpen && hasChatProfile" class="section-6">
                <div class="chat-box-div">
                    <div class="abubody">
                    <!-- Header -->
                    <div class="box-top-div">
                        <div class="chat-top-div">
                            <img :src="logo" loading="lazy" sizes="56.015625px" :srcset="logo" alt="NewSelf Logo" class="image-406" style="height:45px">
                            <a href="#" @click.prevent="toggleChat" class="link-block-56 w-inline-block">
                                <img src="@/assets/images/icon_close_wht.svg" loading="lazy" alt="Close" class="image-407">
                            </a>
                        </div>
                        <!-- Chat Messages -->
                        <div class="chat-body-div">
                            <div class="chat-reco-div" ref="chatContainer">
                                <div class="chat-div">
                                    <div class="dialogue-div" v-for="(message, index) in messages" :key="`chat-message-${index}`">
                                        <!-- User Message -->
                                        <div class="user-div" v-if="message.role === 'user'">
                                            <div class="speech">
                                                <div class="text-block-806" v-html="message.content"></div>
                                                <small v-if="message.timestamp" class="message-timestamp">
                                                    {{ formatTimestamp(message.timestamp) }}
                                                </small>
                                            </div>
                                        </div>
                                        <!-- Assistant Message -->
                                        <div class="platform-div" v-else>
                                            <div class="div-block-1757"></div>
                                            <div class="response-div">
                                                <p class="paragraph-132" v-html="message.content"></p>
                                                <small v-if="message.timestamp" class="message-timestamp">
                                                    {{ formatTimestamp(message.timestamp) }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Input Area -->
                    <div class="box-bottom-div">
                        <div class="chat-area-div">
                            <div class="form-block-2 w-form">
                                <form class="form-10" @submit.prevent="sendMessage">
                                    <textarea  
                                        class="text-field-53 w-input" 
                                        maxlength="256" 
                                        name="message" 
                                        rows="2" 
                                        placeholder="Type your message..." 
                                        v-model="currentMessage"
                                        @keypress.enter="sendMessage"
                                    ></textarea> 
                                    <div 
                                        class="div-block-1754" 
                                        @click="sendMessage"
                                        :class="{ 'disabled': !canSendMessage }"
                                    >
                                        <img 
                                            src="@/assets/images/sendImage.webp" 
                                            loading="lazy" 
                                            alt="Send" 
                                            class="image-413"
                                        >
                                    </div>
                                </form>
                            </div>
                            <div class="chtnote">This is not medical advice. Review our terms for more info.</div>
                        </div>
                    </div>
                </div>
                </div>
            </section>
    
            <!-- Login Section -->
        </transition>
    
        <!-- Chat Bubble Button -->
        <div class="chat-bubble" v-if="!isOpen && checkIcon" @click="toggleChat">
            <img v-if="!isOpen" src="@/assets/images/image.png" alt="Chat" class="chat-bubble-icon">
            <img v-else src="@/assets/images/icon_Close.svg" alt="Close" class="chat-bubble-icon">
        </div>
    </div>
    </template>
    <script>
    import { io } from 'socket.io-client';
    import { format } from 'date-fns';
    
    export default {
        name: 'ChatWindow',
        props: ["hideIconOn"],
        
        data() {
            return {
                appName: "Priority Meds",
                isOpen: false,
                pageOpenedOn: '',
                sessionId: null,
                userId: 'anonymous',
                socket: null,
                messages: [],
                currentMessage: '',
                connectionStatus: 'disconnected',
                logo: process.env.VUE_APP_LOGO,
                loginUrl: process.env.VUE_APP_API_ENDPOINT,
                email: null,
                password: null,
                submitted: false,
                err: false,
                errmsg: "",
                userInitialized: false,
                initializationAttempts: 0,
                maxInitializationAttempts: 3,
                reconnectTimer: null,
                isReconnecting: false,
                socketInitialized: false,
                pendingInitialization: false,
                chatUrl: process.env.VUE_APP_API_ENDPOINT,
                userData: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    source_web: 2,
                    user_type: 'chat'
                }
            }
        },
    
        computed: {
            user(){
                return JSON.parse(localStorage.getItem("user"))
            },    
            userDetails() {
                if (this.isLoggedin && this.user) {
                    return {
                        id: this.user.id,
                        name: `${this.user.first_name} ${this.user.last_name}`.trim(),
                        email: this.user.email
                    };
                } 
                return null;
            },
    
            hasChatProfile() {
                return this.isLoggedin;
            },
    
            isLoggedin() {
                return true;
            },
    
            socketUrl() {
                return this.chatUrl;
            },
    
            canSendMessage() {
                return this.socket?.connected && 
                       this.currentMessage.trim().length > 0 && 
                       !this.isReconnecting;
            },
    
            checkIcon() {
                return this.$route.name === 'userDetails';
            }
        },
    
        watch: {
            userDetails: {
                immediate: true,
                handler(newDetails) {
                    if (newDetails && !this.socketInitialized) {
                        this.initializeSocket();
                    }
                }
            },
    
            isLoggedin(newValue) {
                console.log(newValue)
                return true;
            }
        },
    
        created() {
            if (window.Tracker) {
                this.initializeFromTracker();
            }
            window.addEventListener('sessionInit', this.handleSessionInit);
            window.addEventListener('userIdentified', this.handleUserIdentified);
            this.$root.$on('toggle-chat', this.toggleChat);
        },
        mounted() {
            if (this.isLoggedin) {
                this.initializeFromTracker();
            }
        },
        beforeDestroy() {
            this.cleanup();
        },
    
        methods: {
            async registerUser() {
                try {
                    this.submitted = true;
                    const response = await this.$axios.post(`${this.loginUrl}/api/chat-user`, this.userData);
                    if (response.data.status === 'success') {
                        await this.$store.dispatch("setChatProfile", response.data.user);
                        this.initializeSocket();
                        this.$nextTick(() => {
                            if (this.socket?.connected) {
                                this.initializeUserDetails();
                            } else {
                                console.log('Socket not yet connected after registration');
                            }
                        });
                    } else if(response.data.status === 'error' && response.data.message === 'Existing user found.') {
                        this.$router.push({
                            name: 'LoginPage',
                            query: { "page_ref": "Checkouts" }
                        });
                    }
                    this.submitted = false;
                } catch (error) {
                    console.error('Error during registration:', error);
                    this.errorMessage = 'An error occurred while creating chat profile.';
                    this.submitted = false;
                }
            },
            formatTimestamp(timestamp) {
                if (!timestamp) return '';
                return format(new Date(timestamp), 'HH:mm');
            },
    
            cleanup() {
                window.removeEventListener('sessionInit', this.handleSessionInit);
                window.removeEventListener('userIdentified', this.handleUserIdentified);
                this.cleanupSocket();
                if (this.reconnectTimer) {
                    clearTimeout(this.reconnectTimer);
                }
            },
            initializeFromTracker() {
                if (!this.sessionId) {
                    this.sessionId = window.Tracker?.getSessionId() || `session_${Date.now()}`;
                }
                if (this.isLoggedin && this.user?.id) {
                    this.userId = this.user.id;
                    this.initializeSocket();
                }
            },
    
            initializeSocket() {
                if (this.socket) {
                    this.cleanupSocket();
                }
                const userDetails = this.userDetails;
                if (!userDetails) {
                    return;
                }
                try {
                    const socketConfig = {
                        transports: ['websocket'],
                        query: {
                            sessionId: this.sessionId || `session_${Date.now()}`,
                            userId: userDetails.id || 'anonymous',
                            page: window.location.href
                        },
                        reconnection: true,
                        reconnectionAttempts: 5,
                        reconnectionDelay: 1000,
                        reconnectionDelayMax: 5000,
                        timeout: 10000
                    };
                    this.socket = io(this.socketUrl, socketConfig);
                    this.socketInitialized = true;
                    this.setupSocketListeners();
                } catch (error) {
                    this.socketInitialized = false;
                }
            },

            setupSocketListeners() {
                this.socket.on('connect', this.handleConnect);
                this.socket.on('disconnect', this.handleDisconnect);
                this.socket.on('error', this.handleError);
                this.socket.on('chat_message', this.handleChatMessage);
                this.socket.on('history', this.handleHistory);
                this.socket.on('reconnect_attempt', this.handleReconnectAttempt);
                this.socket.on('reconnect_failed', this.handleReconnectFailed);
            },

            handleConnect() {
                this.connectionStatus = 'connected';
                this.isReconnecting = false;
                if (this.userDetails) {
                    this.initializeUserDetails();
                } else {
                    console.log('No user details available yet');
                }

                if (this.isOpen) {
                    this.loadChatHistory();
                }
            },
    
            handleDisconnect() {
                
                this.connectionStatus = 'disconnected';
                this.startReconnectTimer();
            },
    
            handleError(error) {
                console.error('Socket.IO error:', error);
                this.connectionStatus = 'error';
                if (error.message === 'User not initialized' && 
                    this.initializationAttempts < this.maxInitializationAttempts) {
                    this.retryInitialization();
                }
            },
    
            handleChatMessage(message) {
                console.log(message)
                this.messages.push({
                    role: 'assistant',
                    content: message.content,
                    timestamp: new Date(message.timestamp)
                });
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            },
    
            handleHistory(data) {
                this.messages = data.content
                    .filter(msg => msg.role !== 'system')
                    .map(msg => ({
                        ...msg,
                        timestamp: new Date(msg.timestamp)
                    }));
                this.$nextTick(this.scrollToBottom);
            },
    
            handleReconnectAttempt(attemptNumber) {
                console.log(attemptNumber)
                this.isReconnecting = true;
            },
    
            handleReconnectFailed() {
                
                this.isReconnecting = false;
                this.connectionStatus = 'error';
            },
    
            startReconnectTimer() {
                if (this.reconnectTimer) {
                    clearTimeout(this.reconnectTimer);
                }
                this.reconnectTimer = setTimeout(() => {
                    if (this.isLoggedin) {
                        this.initializeSocket();
                    }
                }, 5000);
            },
    
            retryInitialization() {
                setTimeout(() => {
                    this.initializeUserDetails();
                }, 1000 * (this.initializationAttempts + 1));
                this.initializationAttempts++;
            },
    
            cleanupSocket() {
                if (this.socket) {
                    this.socket.offAny();
                    this.socket.disconnect();
                    this.socket = null;
                    this.socketInitialized = false;
                }
            },
    
            handleSessionInit(event) {
                const { sessionId, userId } = event.detail;
                this.sessionId = sessionId;
                this.userId = userId;
                this.initializeSocket();
            },
    
            handleUserIdentified(event) {
                const { newUserId } = event.detail;
                this.userId = newUserId;
                this.initializeSocket();
            },
    
            initializeUserDetails() {
              
                if (!this.socket?.connected) {
                  
                    this.pendingInitialization = true;
                    return;
                }
                const userData = this.userDetails;
                if (!userData) {
                  
                    return;
                }
                try {
                    if (!userData.email) {
                        console.error('Invalid user data:', userData);
                        return;
                    }
                    this.socket.emit('init_user', userData);
                    this.userInitialized = true;
                    this.initializationAttempts = 0;
                    this.pendingInitialization = false;
                    this.setOnlineStatus();
                    
                } catch (error) {
                    console.error('Error initializing user details:', error);
                    this.pendingInitialization = true;
                }
            },
            setOnlineStatus(){
                setInterval(() => {
                    this.socket.to('customer_service_reps').emit('user_online', {
                        userId: this.userData.id,
                        userName: this.userData.name,
                        userEmail: this.userData.email,
                        timestamp: new Date()
                    });
                }, 2 * 60 * 1000); // 2 minutes interval
            },
            async sendMessage() {
                if (!this.canSendMessage) return;
                
                try {
                    const userMessage = {
                        role: 'user',
                        content: this.currentMessage.trim(),
                        timestamp: new Date()
                    };
                    
                    this.messages.push(userMessage);
                    
                    this.socket.emit('chat message', {
                        userId: this.userId,
                        message: this.currentMessage.trim()
                    });
                    
                    this.currentMessage = '';
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });
                    
                } catch (error) {
                    console.error('Error sending message:', error);
                    this.showError('Failed to send message. Please try again.');
                }
            },
    
            loadChatHistory() {
                if (this.socket?.connected) {
                    this.socket.emit('load_history');
                }
            },
    
            toggleChat() {
                this.isOpen = !this.isOpen;
                if (this.isOpen) {
                    this.pageOpenedOn = {
                        path: this.$route.path,
                        fullPath: this.$route.fullPath,
                        name: this.$route.name,
                        query: this.$route.query,
                        params: this.$route.params,
                        url: window.location.href,
                        openedAt: new Date().toISOString()
                    };
                    
                    if (this.isLoggedin || this.$store.getters.hasChatProfile) {
                        if (!this.socket?.connected) {
                            this.initializeSocket();
                        }
                        this.loadChatHistory();
                        if (!this.userInitialized) {
                            this.initializeUserDetails();
                        }
                    }
                }
            },
    
            scrollToBottom() {
                const chatContainer = this.$refs.chatContainer;
                if (chatContainer) {
                    chatContainer.scrollTop = chatContainer.scrollHeight;
                }
            },
    
            showError(message) {
                this.err = true;
                this.errmsg = message;
                setTimeout(() => {
                    this.err = false;
                    this.errmsg = '';
                }, 3000);
            },
    
            async onSubmit() {
                this.submitted = true;
                try {
                    await this.$store.dispatch('login', {
                        email: this.email,
                        password: this.password
                    });
                    this.submitted = false;
                    this.err = false;
                } catch (error) {
                    this.submitted = false;
                    this.err = true;
                    this.errmsg = error.message || 'Login failed. Please try again.';
                }
            }
        }
    };
    </script>
    
    <style scoped>
    /* Chat Window Container */
.chat-bubble-container {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
}

/* Chat Bubble Button */
.chat-bubble {
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.chat-bubble:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.2);
}

.chat-bubble-icon {
    width: 35px;
    height: 35px;
    object-fit: contain;
}

/* Main Chat Window */
.section-6 {
    position: fixed;
    bottom: 90px;
    right: 20px;
    width: 380px;
    height: 600px;
    z-index: 999;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.chat-box-div {
    width: 100%;
    height: 100%;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.abubody {
    display: flex;
    flex-direction: column;
    height: 100%;
}

/* Header Section */
.box-top-div {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0; /* Important for flex child to shrink */
}

.chat-top-div {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    flex-shrink: 0; /* Header doesn't shrink */
}

.image-406 {
    height: 45px;
    width: auto;
}

.link-block-56 {
    cursor: pointer;
    padding: 5px;
    border-radius: 50%;
    transition: background-color 0.2s ease;
}

.link-block-56:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

.image-407 {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
}

/* Chat Body */
.chat-body-div {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0; /* Important for flex child to shrink */
}

.chat-reco-div {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
    padding-bottom: 20px; /* Reduced from 240px */
    min-height: 0; /* Important for flex child to shrink */
}

.chat-div {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

/* Welcome Section */
.chat-body-top {
    text-align: center;
    margin-bottom: 20px;
}

.text-block-788 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
}

/* Message Styles */
.dialogue-div {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* User Messages */
.user-div {
    display: flex;
    justify-content: flex-end;
}

.speech {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 12px 16px;
    border-radius: 18px 18px 4px 18px;
    max-width: 80%;
    word-wrap: break-word;
    position: relative;
}

.text-block-806 {
    font-size: 14px;
    line-height: 1.4;
    margin: 0;
}

/* Assistant Messages */
.platform-div {
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.div-block-1757 {
    width: 32px;
    height: 32px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    flex-shrink: 0;
    margin-top: 4px;
}

.response-div {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    padding: 12px 16px;
    border-radius: 18px 18px 18px 4px;
    max-width: 80%;
    word-wrap: break-word;
}

.paragraph-132 {
    font-size: 14px;
    line-height: 1.4;
    color: #333;
    margin: 0;
}

/* Message Timestamps */
.message-timestamp {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.7);
    margin-top: 4px;
    display: block;
}

.platform-div .message-timestamp {
    color: #6c757d;
}

/* Input Area */
.box-bottom-div {
    background: white;
    border-top: 1px solid #e9ecef;
    padding: 15px 20px;
    flex-shrink: 0; /* Important: Input area doesn't shrink */
    position: relative;
}

.chat-area-div {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.form-block-2 {
    position: relative;
}

.form-10 {
    position: relative;
    display: flex;
    align-items: flex-end;
}

.text-field-53 {
    flex: 1;
    border: 1px solid #dee2e6;
    border-radius: 20px;
    padding: 12px 50px 12px 16px;
    font-size: 14px;
    resize: none;
    outline: none;
    transition: border-color 0.2s ease;
    font-family: inherit;
    margin: 0;
    min-height: 40px; /* Ensure minimum height */
    max-height: 80px; /* Prevent it from growing too large */
}

.text-field-53:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.div-block-1754 {
    position: absolute;
    right: 5px;
    bottom: 5px;
    width: 36px;
    height: 36px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.2s ease, opacity 0.2s ease;
}

.div-block-1754:hover {
    transform: scale(1.05);
}

.div-block-1754.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.div-block-1754.disabled:hover {
    transform: none;
}

.image-413 {
    width: 20px;
    height: 20px;
    filter: brightness(0) invert(1);
}

.chtnote {
    font-size: 11px;
    color: #6c757d;
    text-align: center;
    margin-top: 8px;
}

/* Login Form Styles */
._2-input-div {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
}

.tf_textfield-2 {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s ease;
}

.tf_textfield-2:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.tf_textfield-2.half {
    flex: 1;
}

.checkout-button-2 {
    width: 100%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.2s ease;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
}

.checkout-button-2:hover {
    transform: translateY(-1px);
}

.text-block-865 {
    font-size: 11px;
    color: #6c757d;
    text-align: center;
    line-height: 1.4;
}

/* Transition Animations */
.fade-scale-enter-active,
.fade-scale-leave-active {
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.fade-scale-enter,
.fade-scale-leave-to {
    opacity: 0;
    transform: scale(0.95) translateY(20px);
}

/* Scrollbar Styling */
.chat-reco-div::-webkit-scrollbar {
    width: 4px;
}

.chat-reco-div::-webkit-scrollbar-track {
    background: transparent;
}

.chat-reco-div::-webkit-scrollbar-thumb {
    background: #dee2e6;
    border-radius: 2px;
}

.chat-reco-div::-webkit-scrollbar-thumb:hover {
    background: #adb5bd;
}

/* Mobile Responsive */
@media only screen and (max-width: 767px) {
    .section-6 {
        width: calc(100vw - 40px);
        height: calc(100vh - 140px);
        bottom: 20px;
        left: 20px;
        right: 20px;
    }
    
    .chat-reco-div {
        padding-bottom: 20px; /* Reduced from 163px */
    }
    
    .chat-bubble-container {
        bottom: 20px;
        right: 20px;
    }
}

@media only screen and (max-width: 480px) {
    .section-6 {
        width: calc(100vw - 20px);
        left: 10px;
        right: 10px;
    }
    
    .speech,
    .response-div {
        max-width: 90%;
    }
    
    ._2-input-div {
        flex-direction: column;
        gap: 10px;
    }
    
    .tf_textfield-2.half {
        width: 100%;
    }
}

/* Loading Animation */
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.checkout-button-2 svg {
    animation: spin 0.5348s linear infinite;
}

/* Focus Management */
.chat-box-div:focus-within {
    box-shadow: 0 10px 40px rgba(102, 126, 234, 0.2);
}

/* High Contrast Mode Support */
@media (prefers-contrast: high) {
    .speech {
        background: #000;
        color: #fff;
        border: 2px solid #fff;
    }
    
    .response-div {
        background: #fff;
        color: #000;
        border: 2px solid #000;
    }
    
    .div-block-1757 {
        background: #000;
        border: 2px solid #fff;
    }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
    .chat-bubble,
    .div-block-1754,
    .checkout-button-2,
    .fade-scale-enter-active,
    .fade-scale-leave-active {
        transition: none;
    }
    
    .checkout-button-2 svg {
        animation: none;
    }
}
    </style>
    